import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=6e048487&scoped=true&"
import script from "./ForgotPassword.js?vue&type=script&lang=js&"
export * from "./ForgotPassword.js?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=6e048487&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e048487",
  null
  
)

export default component.exports